/* "Light them up": the stall hero. Lamps light one by one on load, hover or tap lights a dark one,
   the switch lights them all in a wave across the shelf and turns them out again. */
const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const hover = matchMedia('(hover: hover) and (pointer: fine)');

function initStall(stall) {
  if (stall._laReady) return;
  stall._laReady = true;
  const lamps = Array.from(stall.querySelectorAll('[data-la-lamp]'));
  if (!lamps.length) return;
  const allBtn = stall.querySelector('[data-la-all]');
  const allLbl = stall.querySelector('[data-la-all-label]');
  const count = stall.querySelector('[data-la-lit]');
  const rows = Math.max(...lamps.map((l) => +l.dataset.row)) + 1;
  const maxStep = 2 + rows - 1;
  let timers = [];
  stall.style.setProperty('--lamps', lamps.length);

  const sync = () => {
    const n = lamps.filter((l) => l.classList.contains('is-lit')).length;
    stall.style.setProperty('--lit', n);
    if (count) count.textContent = n;
    const all = n === lamps.length;
    if (allBtn) allBtn.setAttribute('aria-pressed', String(all));
    stall.classList.toggle('is-all', all);
    if (allLbl && allBtn) allLbl.textContent = all ? allBtn.dataset.off : allBtn.dataset.on;
  };
  const set = (lamp, on) => {
    if (lamp.classList.contains('is-lit') === on) return;
    lamp.classList.toggle('is-lit', on);
    const sw = lamp.querySelector('.la-lamp__sw');
    const card = lamp.querySelector('.la-tag__card');
    sw.setAttribute('aria-pressed', String(on));
    sw.setAttribute('aria-label', on ? lamp.dataset.onLabel : lamp.dataset.offLabel);
    if (card) {
      card.tabIndex = on ? 0 : -1;
      if (on) card.removeAttribute('aria-hidden');
      else card.setAttribute('aria-hidden', 'true');
    }
    sync();
  };
  const cancel = () => { timers.forEach(clearTimeout); timers = []; };

  lamps.forEach((l) => {
    const sw = l.querySelector('.la-lamp__sw');
    sw.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'mouse' && hover.matches && !l.classList.contains('is-lit')) {
        set(l, true);
        l.dataset.hov = Date.now();
      }
    });
    sw.addEventListener('click', () => {
      cancel();
      if (l.dataset.hov && Date.now() - l.dataset.hov < 700) return;
      l.dataset.hov = '';
      set(l, !l.classList.contains('is-lit'));
    });
  });
  if (allBtn) {
    allBtn.addEventListener('click', () => {
      cancel();
      const on = allBtn.getAttribute('aria-pressed') !== 'true';
      lamps.forEach((l) => {
        const step = +l.dataset.col + +l.dataset.row;
        const wait = reduced() ? 0 : (on ? step : maxStep - step) * (on ? 130 : 70);
        timers.push(setTimeout(() => set(l, on), wait));
      });
    });
  }

  /* opening: the first lamp flickers on, then the load wave runs across the shelf */
  const first = lamps.find((l) => l.hasAttribute('data-first')) || lamps[0];
  if (reduced() || document.documentElement.classList.contains('la-lite')) {
    lamps.forEach((l) => set(l, true));
    return;
  }
  sync();
  const start = () => {
    timers.push(setTimeout(() => set(first, true), 450));
    lamps.filter((l) => l !== first).forEach((l) => {
      const step = +l.dataset.col + +l.dataset.row;
      timers.push(setTimeout(() => set(l, true), 1250 + step * 140));
    });
  };
  /* wait until the shelf is on screen, so a deep link doesn't burn the wave off-screen */
  const io = new IntersectionObserver((es) => {
    if (es.some((e) => e.isIntersecting)) { io.disconnect(); start(); }
  }, { threshold: 0.15 });
  io.observe(stall.querySelector('.la-cabinet') || stall);
}

const run = (scope = document) => scope.querySelectorAll('[data-la-stall]').forEach(initStall);
run();
document.addEventListener('shopify:section:load', (e) => run(e.target));
